import { getMixedMediaCapabilityForService } from '../store/capabilitySlice/getMixedMediaCapabilityForService'

export type MediaMixConflict = 'mixedMediaTypes' | 'multipleVideos'

export interface DraftMediaCounts {
  // A GIF maps to an image AssetInput server-side (see mapGif), so it
  // conflicts with attached video the same way an image does.
  imageLikeCount: number
  videoCount: number
}

/**
 * Flags a draft whose attached media its own channel can't publish — e.g. a
 * channel-less draft's mixed content copied onto a newly selected channel,
 * or a channel added alongside a sibling that already carries an
 * incompatible mix. Mirrors the backend's noMixedMediaRule/singleVideoRule
 * so the composer can warn before save instead of only after it fails.
 * @see domains/updates-domain/src/use-cases/create/validators/rules/assets/galleryMixRules.ts
 */
export function getMediaMixConflict(
  serviceName: string,
  media: DraftMediaCounts,
): MediaMixConflict | null {
  const capability = getMixedMediaCapabilityForService(serviceName)

  if (
    !capability.canMixMediaTypes &&
    media.imageLikeCount > 0 &&
    media.videoCount > 0
  ) {
    return 'mixedMediaTypes'
  }

  if (!capability.canHaveMultipleVideos && media.videoCount > 1) {
    return 'multipleVideos'
  }

  return null
}
